"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.name = exports["default"] = exports.availableProps = void 0;
var _react = _interopRequireDefault(require("react"));
var _selectors = require("../Theme/selectors");
var _template = _interopRequireDefault(require("./template"));
var _excluded = ["color"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var Folder = function Folder(_ref) {
  var color = _ref.color,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_template["default"], _extends({}, otherProps, {
    renderPaths: function renderPaths(uiTheme) {
      var style = {};
      if (color) {
        style.fill = (0, _selectors.getColor)(uiTheme, color);
      }
      return /*#__PURE__*/_react["default"].createElement("path", {
        style: style,
        d: "M32.8,10.25 C34.56,10.25 36,11.7125 36,13.5 L36,29.75 C36,31.5375 34.56,33 32.8,33 L7.2,33 C5.44,33 4,31.5375 4,29.75 L4.016,10.25 C4.016,8.4625 5.44,7 7.2,7 L16.8,7 L20,10.25 L32.8,10.25 Z M32.8,29.75 L32.8,13.5 L7.2,13.5 L7.2,29.75 L32.8,29.75 Z"
      });
    }
  }));
};
Folder.defaultProps = {
  color: null
};
var _default = exports["default"] = Folder;
var name = exports.name = 'Folder';
var availableProps = exports.availableProps = ['color'];